// extracted by mini-css-extract-plugin
module.exports = {"matchCentreLineUps":"matchCentreLineUps_matchCentreLineUps__MsZOa"};